import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../state/AuthContext";

export default function AppNavbar() {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setSidebarOpen(false);
    }
    setOpenMenu(null);
  }, [location.pathname]);

  const sections = useMemo(() => {
    if (!user) return [];

    const items = [
      {
        id: "master",
        label: "Master",
        roles: ["admin"],
        links: [
          { to: "/master/work-types", label: "Work Type Master" },
          { to: "/master/works", label: "Work Master" },
          { to: "/master/enquiry-statuses", label: "Enquiry Status" },
          { to: "/master/users", label: "Users" },
        ],
      },
      {
        id: "entry",
        label: "Entry",
        roles: ["admin", "team_member"],
        links: [
          { to: "/entry/new-lead", label: "New Lead" },
          { to: "/entry/follow-up", label: "Follow Up" },
          { to: "/entry/all-leads", label: "All Leads" },
          { to: "/entry/whatsapp-reminders", label: "WhatsApp Reminders 💬" },
          { to: "/entry/birthday-reminders", label: "Birthday Reminders 🎂" },
          ...(user.role === "admin"
            ? [{ to: "/entry/pending-balances", label: "Pending Balances 💰" }]
            : []),
        ],
      },
      {
        id: "report",
        label: "Report",
        roles: ["admin", "team_member"],
        links: [{ to: "/reports", label: "All Reports" }],
      },
      {
        id: "settings",
        label: "Settings",
        roles: ["admin"],
        links: [{ to: "/settings", label: "User Settings & Excel Upload" }],
      },
    ];

    return items.filter((section) => section.roles.includes(user.role));
  }, [user]);

  const homePath = user ? "/dashboard" : "/customer";

  const toggleMenu = (menuId) => {
    setOpenMenu((current) => (current === menuId ? null : menuId));
  };

  return (
    <>
      <nav className="navbar navbar-dark bg-dark sticky-top shadow-sm">
        <div className="container-fluid">
          <div className="d-flex align-items-center gap-2">
            {user ? (
              <button
                type="button"
                className="btn btn-outline-light btn-sm"
                aria-label="Toggle sidebar"
                onClick={() => setSidebarOpen((current) => !current)}
              >
                Menu
              </button>
            ) : null}
            <Link className="navbar-brand mb-0 fw-bold" to={homePath}>
              MK MOTORS
            </Link>
          </div>

          {!user ? (
            <div className="d-flex align-items-center gap-2">
              <NavLink className="btn btn-outline-light btn-sm" to="/customer">
                Customer
              </NavLink>
              <NavLink className="btn btn-light btn-sm" to="/login">
                Login
              </NavLink>
            </div>
          ) : (
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span className="text-white-50 small">
                <strong>{user.name}</strong> ({user.role === "admin" ? "Admin" : "Team Member"})
              </span>
              <button className="btn btn-outline-light btn-sm" onClick={logout}>
                Logout
              </button>
            </div>
          )}
        </div>
      </nav>

      {user ? (
        <>
          <aside className={`app-sidebar bg-light border-end shadow-sm ${sidebarOpen ? "show" : ""}`}>
            <div className="sidebar-header border-bottom px-3 py-3 d-flex justify-content-between align-items-center">
              <span className="fw-semibold">Menu</span>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary d-md-none"
                onClick={() => setSidebarOpen(false)}
              >
                Close
              </button>
            </div>

            <div className="list-group list-group-flush">
              <NavLink
                className="list-group-item list-group-item-action border-0 py-3"
                to="/dashboard"
              >
                Dashboard
              </NavLink>

              {sections.map((section) => (
                <div key={section.id}>
                  <button
                    type="button"
                    className="list-group-item list-group-item-action bg-dark text-white fw-semibold border-0 py-3 d-flex justify-content-between align-items-center"
                    onClick={() => toggleMenu(section.id)}
                  >
                    <span>{section.label}</span>
                    <span>{openMenu === section.id ? "-" : "+"}</span>
                  </button>
                  <div className={`collapse ${openMenu === section.id ? "show" : ""}`}>
                    {section.links.map((link) => (
                      <NavLink
                        key={link.to}
                        className="list-group-item list-group-item-action border-0 ps-4 py-2"
                        to={link.to}
                      >
                        {link.label}
                      </NavLink>
                    ))}
                  </div>
                </div>
              ))}

              <NavLink
                className="list-group-item list-group-item-action border-0 py-3"
                to="/customer"
              >
                Customer Form
              </NavLink>
            </div>
          </aside>

          {sidebarOpen ? (
            <div className="app-sidebar-overlay d-md-none" onClick={() => setSidebarOpen(false)} />
          ) : null}
        </>
      ) : null}
    </>
  );
}
